import {BrowserModule} from "@angular/platform-browser";
import {APP_INITIALIZER, ErrorHandler, Injector, LOCALE_ID, NgModule} from "@angular/core";
import {VisBosComponent} from "./visbos.component";
import {Apollo, ApolloModule} from "apollo-angular";
import {NgRedux, NgReduxModule} from "@angular-redux/store";
import {SessionActions} from "./shared/actions/session.actions";
import {ReduxRouteService} from "./shared/redux-store/redux-route.service";
import {GraphqlService} from "./shared/graphql/graphql.service";
import {VisbosCoreModule} from "./core/visbos-core/visbos-core.module";
import ApolloClient from "apollo-client/ApolloClient";
import {createNetworkInterface, IntrospectionFragmentMatcher, toIdValue} from "apollo-client";
import {CRMModule} from "./crm/crm.module";
import {VisbosClientModule} from "./visbos-client/visbos-client.module";
import {VisbosTouchClientModule} from "./visbos-touch-client/visbos-touch-client.module";
import {DatePipe, DecimalPipe, registerLocaleData} from "@angular/common";
import {VisBosRoutingModule} from "./visbos-routing.module";
import {IAppState, rootReducer} from "./shared/redux-store/store";
import {appInjector} from "./index";
import {enhancers, middleware} from "./shared/redux-store/index";
import {VisbosErrorHandlerService} from "./core/visbos-core/error-handling/visbos-error-handler.service";
import {AdminUnitActions} from "./shared/actions/admin-unit.actions";
import {Barcode} from "./identity/model/barcode.interface";

import localeDe from '@angular/common/locales/de'
import {observableResult} from "./core/visbos-core/graphql/handleObservable";
import {Observable} from "rxjs/Observable";
import {HTTP_INTERCEPTORS, HttpClient} from "@angular/common/http";
import {MaintenanceInterceptor} from "./core/visbos-core/maintenance/maintenance.interceptor";
import {Router} from "@angular/router";
import {AuthorizationHeadersInterceptor} from "./core/visbos-core/http/authorization-headers.interceptor";

const apolloNetworkInterface = createNetworkInterface({
  //uri: environment.graphqlUrl,
  uri: 'api/graphql',
  opts: {
    headers: new Headers({'Access-Control-Request-Headers': 'Authorization'})
  }
});

const cuidFromObject = (o: any) => {
  if ((<Barcode>o).ean) { // For Barcodes, identify them by the EAN code.
    return o.__typename + ':' + o.ean;
  }
  // For all others, identify them by their cuid
  return o.cuid;
};

const fm = new IntrospectionFragmentMatcher(
  {
    introspectionQueryResultData: {
      __schema: {
        types: [{
          kind: 'INTERFACE',
          name: 'IdentifiableInterface',
          possibleTypes: [{name: 'Stock'}, {name: 'AdministrationUnit'}, {name: 'Vehicle'}]
        }]
      }
    }
  }
);

/**
 * Custom resolvers, used for cache redirects
 */
const res = {
  Query: {
    barcode: (_, args) => toIdValue(client.dataIdFromObject({__typename: 'Barcode', ean: args.ean}))
  }
};

const client = new ApolloClient({
  networkInterface: apolloNetworkInterface,
  fragmentMatcher: fm,
  customResolvers: res,
  queryDeduplication: true,
  dataIdFromObject: cuidFromObject
});

export function provideClient(): ApolloClient {
  return client;
}

// Globally register DE local for i18n support
registerLocaleData(localeDe);

export function provideAppInitializer(): Function {
  return () => {

  }
}

@NgModule({
  declarations: [
    VisBosComponent
  ],
  imports: [
    NgReduxModule,
    ApolloModule.forRoot(provideClient),
    BrowserModule,
    CRMModule,
    VisbosCoreModule,
    VisbosClientModule,
    VisbosTouchClientModule,
    VisBosRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MaintenanceInterceptor,
      deps: [Injector],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHeadersInterceptor,
      deps: [NgRedux],
      multi: true
    },
    ReduxRouteService,
    SessionActions, GraphqlService, AdminUnitActions,//TODO Refactor to core
    //{provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: APP_INITIALIZER,
      useFactory: provideAppInitializer,
      //deps: [SessionActions, UserService, VisbosService],
      multi: true
    },
    DatePipe, DecimalPipe,
    {provide: ErrorHandler, useClass: VisbosErrorHandlerService}, // Use own error handler
    {provide: LOCALE_ID, useValue: "de-DE"}, // Set local to german
  ],
  bootstrap: [VisBosComponent]
})
export class VisBosModule {

  constructor(private injector: Injector,
              private ngRedux: NgRedux<IAppState>,
              private apollo: Apollo,
              private router: Router,
              private http: HttpClient,
              private sessionActions: SessionActions) {



    // Add custom operator to Observables, to handle asynchronous calls ans observable feedback
    //Observable.prototype.handleObservable = handleObservable;
    Observable.prototype.observableResult = observableResult;

    // Store injector instance in globl variable for global access in VisBOS
    appInjector(injector);

    // Configure the Redux store and router (already configured in InitAppGuard, because component is bootstrapped after guard since Angular 2.4.8)
    try {
      this.ngRedux.configureStore(rootReducer, {}, middleware, enhancers);
    } catch (e) {
      console.warn("Redux store already configured!");
    }

    apollo.getClient().networkInterface = GraphqlService.initNetworkInterface(this.ngRedux, this.sessionActions);

  }

}



// WEBPACK FOOTER //
// ./src/app/visbos.module.ts